import React from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'

import { StoreProduct, Money } from 'protos'

import Paper from 'components/Paper'
import StoreItem from 'components/StoreItem'

const price: Money[] = [
  Money.create({ currency: 0, value: 99.99 }),
]

const items: StoreProduct[] = [
  StoreProduct.create(),
  StoreProduct.create({ price }),
  StoreProduct.create({ price, quantity: 30 }),
  ...[0, 1, 2, 3, 4, 5, 6].map((level) => StoreProduct.create({
    price,
    level,
    type: StoreProduct.Type.COIN,
    quantity: 2000 * (level + 1),
  }))
]

storiesOf('StoreItem', module)
  .addDecorator((story) => (
    <Paper style={{ padding: 24, backgroundColor: '#EEE' }}>
      {story()}
    </Paper>
  ))
  .add('default', () => (
    <Grid direction="row" wrap="wrap" spacing={2} container>
      {items.map((item, i) => (
        <Grid key={`item-${i}`} item>
          <StoreItem {...item} />
        </Grid>
      ))}
    </Grid>
  ))
